import { render, staticRenderFns } from "./workouts-slider.vue?vue&type=template&id=f0936220&"
import script from "./workouts-slider.vue?vue&type=script&lang=js&"
export * from "./workouts-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports